export function CrownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="40 40 24 24"
      fill="none"
    >
      <clipPath id="crownBadgeClip">
        <path d="M40 52C40 45.3726 45.3726 40 52 40C58.6274 40 64 45.3726 64 52C64 58.6274 58.6274 64 52 64C45.3726 64 40 58.6274 40 52Z" />
      </clipPath>
      <g clipPath="url(#crownBadgeClip)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52 41.6568L50.0677 40.7123C48.9175 40.15 47.5286 40.6013 46.9285 41.7323L45.9204 43.6322L43.802 44.0038C42.5409 44.225 41.6826 45.4065 41.8619 46.6742L42.1631 48.8038L40.6677 50.3496C39.7774 51.2698 39.7775 52.7302 40.6677 53.6504L42.1631 55.1962L41.8619 57.3258C41.6826 58.5935 42.5409 59.7749 43.802 59.9962L45.9204 60.3678L46.9285 62.2677C47.5286 63.3987 48.9175 63.8499 50.0677 63.2877L52 62.3431L53.9323 63.2877C55.0825 63.8499 56.4714 63.3987 57.0715 62.2677L58.0796 60.3678L60.198 59.9961C61.4591 59.7749 62.3175 58.5935 62.1381 57.3258L61.8369 55.1962L63.3323 53.6504C64.2226 52.7301 64.2225 51.2698 63.3323 50.3496L61.8369 48.8038L62.1381 46.6742C62.3174 45.4065 61.4591 44.225 60.198 44.0038L58.0796 43.6322L57.0715 41.7323C56.4714 40.6013 55.0825 40.15 53.9323 40.7123L52 41.6568Z"
          fill="#FFFFFF"
        />
        <path
          d="M56.6543 45.5352L60.0127 46.1289L59.5352 49.5303L61.9062 52L59.5352 54.4697L60.0127 57.8711L56.6543 58.4648L55.0566 61.5L51.9932 59.9912L48.9297 61.5L47.332 58.4648L43.9736 57.8711L44.4512 54.4697L42.0801 52L44.4512 49.5303L43.9736 46.1289L47.332 45.5352L48.9297 42.5L51.9932 44.0088L55.0566 42.5L56.6543 45.5352ZM52.3555 48.9443C52.183 48.6856 51.8034 48.6856 51.6309 48.9443L49.998 51.3926C49.8489 51.6164 49.5423 51.6691 49.3271 51.5078L47.3662 50.0371C47.1216 49.8537 46.7777 50.0601 46.8242 50.3623C47.034 51.7259 47.2443 53.8865 47.4541 55.25H56.5322C56.742 53.8865 56.9523 51.7259 57.1621 50.3623C57.2086 50.0601 56.8648 49.8539 56.6201 50.0371L54.6592 51.5078C54.444 51.6692 54.1375 51.6163 53.9883 51.3926L52.3555 48.9443Z"
          fill="#FF5010"
        />
      </g>
    </svg>
  );
}
